import { StylesConfig } from "react-select";

import { ReactSelect, ReactSelectProps } from "@/components/Selects/ReactSelect";

type OptionsStatus = {
	value: string;
	label: string;
	color: string;
	background: string;
};

type Props = ReactSelectProps;

export function StatusSelect({ ...rest }: Props) {
	const optionsStatus = [
		{ value: "Faturado", label: "Faturado", background: "#009ef7", color: "#fff" },
		{
			value: "Aguardando Faturamento",
			label: "Aguardando Faturamento",
			background: "#e4e6ef",
			color: "#000",
		},
		{ value: "Finalizado", label: "Finalizado", background: "#50cd89", color: "#fff" },
		{
			value: "Pendente Autorização",
			label: "Pendente n° de AIH",
			background: "#7239ea",
			color: "#fff",
		},
		{
			value: "Aguardando internamento",
			label: "Apto para internamento",
			background: "#ffc700",
			color: "#fff",
		},
		{
			value: "Aguardando Autorização",
			label: "Aguardando Autorização",
			background: "#f1416c",
			color: "#fff",
		},
	];

	const optionsStatusStyles: StylesConfig<OptionsStatus> = {
		option: (styles, { data }) => ({
			...styles,
			color: data.background,
		}),
		multiValue: (styles) => ({
			...styles,
			borderRadius: "1rem",
		}),
		multiValueLabel: (styles, { data }) => ({
			...styles,
			backgroundColor: data.background,
			color: data.color,
			borderRadius: "0.5rem",
		}),
		multiValueRemove: (styles) => ({
			...styles,
			display: "none",
		}),
	};

	return (
		<ReactSelect
			isMulti
			isSolid
			className="mb-1"
			options={optionsStatus}
			styles={optionsStatusStyles}
			{...rest}
		/>
	);
}
